






















































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import IndicatorValue from "@/models/indicator/indicatorValue.model";
import IndicatorService from "@/services/indicator.service";
import baseSelect from '@/components/base/baseSelect/baseSelect.vue';
import { Utils } from "@/core/Utils";
@Component
export default class IndicatorValueTableComponent extends GenericBTable<any> {

indicatorValueService:IndicatorService = new IndicatorService();
indicatorValues:Array<IndicatorValue> = [];
loadedindicatorValues:Array<IndicatorValue> = [];
values:Array<IndicatorValue> = [];
groupId:number = null;
typeId:number = null;
  created() {
   this.tableConfig.controller = "Indicators";
   this.tableConfig.whereParams = `indicatorType/IndicatorGroup/deleted eq false and indicatorType/deleted eq false`
      this.getALLIndicatorValue();
    this.formatColumns();
    
  }

  filtterByType(row:any){
    this.tableConfig.whereParams = `indicatorTypeId eq  ${row.id}` 
    this.tableConfig.reload();
  }
  filtterByGroup(row:any){
     this.tableConfig.whereParams = `indicatorType/IndicatorGroup/id eq  ${row.id}`  
    this.tableConfig.reload();
  }

  save(){
      this.indicatorValueService.saveIndicatorValue(this.values).then( resp =>{
        this.operationSuccess();
        this.getALLIndicatorValue();
      })
    this.tableConfig.reload();
  }

getALLIndicatorValue(){
  this.indicatorValueService.getIndicator().then( resp =>{
    this.loadedindicatorValues = resp;
  })
}
  formatColumns() {
    let name = new BTableColumn("name", "Indicador", false);
    let value = new BTableColumn("value", "Valor", false);
    this.tableConfig.insertColumns(name,value);
      value.customTemplate = true;
      this.tableConfig.activeActions = false;
  }

  getIndicatorValue(indicatorId: number) {
    let objectFinded =  this.loadedindicatorValues.find(x => x.indicatorId == indicatorId);
    return objectFinded ? this.thousandSeprator(objectFinded.value)  : "";
  }

  thousandSeprator(value:any) {
    	if (value !== '' || value !== undefined || value !== 0 || value !== '0' || value !== null) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
        return value;
    }
  }

saveIndicatorValue(value:number,indicatorId:number){
    let objFinded = this.indicatorValues.find(x => x.indicatorId == indicatorId);
    if(objFinded){
      objFinded.value = value;
       for (let index = 0; index < this.indicatorValues.length; index++) {
            let currentIndicatorValue = this.indicatorValues[index];
        if(objFinded.indicatorId == currentIndicatorValue.indicatorId){
            if(!this.values.some(y => y.indicatorId == objFinded.indicatorId)){
              this.values.push(objFinded);
             break;
            }else{
              let index =  this.values.findIndex(p => p.id == currentIndicatorValue.indicatorId);
              this.values.splice(index,1);
              this.values.push(objFinded);
                break;
            }
        } 
      }
    }
    else{
      let item = new IndicatorValue();
      item.value = value;
      item.indicatorId = indicatorId;
      this.indicatorValues.push(item);
    }
}
  Export(){
     var url = process.env.VUE_APP_BASE_URL_REPORT +`Report/DownloadFileExcelIndicadores?groupId=${this.groupId}&typeId=${this.typeId}`  ;
     Utils.downloadURI(url, "Indicadores.xls");
}
}
